<template>
<!-- Empty not so empty -->
  <card style="height:30vh">
    <div>
      <p class="d-flex justify-content-center text-muted">Nenhuma informação por enquanto.</p>
      <p class="d-flex justify-content-center text-muted">{{ suggestion }}</p>
      <div class="text-center mt-4">
        <img class="rounded" style="width: 85px" src="../assets/no-data.png" alt="Image placeholder">
      </div>
    </div>
  </card>
</template>

<script>
export default {
  name: 'empty_data',
  props: {
    suggestion: {
      type: String
    }
  }
}
</script>

<style>

</style>